import React from "react";
import { useMediaQuery } from "react-responsive";

export default function Page({ children }) {
  const mediaQuery = {
    isDesktopOrLaptop: useMediaQuery({ query: "(min-width: 1224px)" }),
    isBigScreen: useMediaQuery({ query: "(min-width: 1824px)" }),
    isTabletOrMobile: useMediaQuery({ query: "(max-width: 1224px)" }),
    isPortrait: useMediaQuery({ query: "(orientation: portrait)" }),
    isRetina: useMediaQuery({ query: "(min-resolution: 2dppx)" })
  };
  return (
    <div
      style={{
        fontFamily: "BentonSansLight",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "400",
        padding: `0 ${mediaQuery.isTabletOrMobile ? "1rem" : "3rem"}`,
        textTransform: "none"
      }}
    >
      {children}
    </div>
  );
}
